import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import _ from 'lodash';

import './dropzone.scss';

const CLASS_NAME = 'brzw-dropzone';

const DropzoneComponent = ({ accept, multiple, imageSrc, title, fileType, onDrop }) => {
  const [formatError, onSetFormatError] = useState(false);
  const onDropFiles = files => {
    onDrop(files);
    onSetFormatError(_.isEmpty(files));
  };
  return (
    <Dropzone accept={accept} onDrop={onDropFiles} multiple={multiple}>
      {({ getRootProps, getInputProps, isDragActive }) => (
        <div
          {...getRootProps()}
          className={classnames(CLASS_NAME, {
            [`${CLASS_NAME}--drag-active`]: isDragActive,
            [`${CLASS_NAME}--format-error`]: formatError,
          })}
        >
          <input {...getInputProps()} />
          <div className={`${CLASS_NAME}__content`}>
            {!_.isEmpty(imageSrc) && (
              <img alt="Dropzone" className={`${CLASS_NAME}__image`} src={imageSrc} />
            )}
            <div className={`${CLASS_NAME}__title`}>{title}</div>
            <div className={`${CLASS_NAME}__subtitle`}>
              your {fileType && fileType} file here, or
              <span className={`${CLASS_NAME}__subtitle--link`}> browse</span>.
            </div>
          </div>
        </div>
      )}
    </Dropzone>
  );
};

DropzoneComponent.propTypes = {
  accept: PropTypes.string,
  fileType: PropTypes.string,
  imageSrc: PropTypes.string,
  multiple: PropTypes.bool,
  onDrop: PropTypes.func,
  title: PropTypes.string,
};

DropzoneComponent.defaultProps = {
  multiple: false,
  title: 'Drag & drop',
};

export default DropzoneComponent;
